<h5 mat-dialog-title i18n>Email Log Report</h5>
<div mat-dialog-content>
  <p i18n>Please define the filters below</p>
</div>
<form #parameterForm="ngForm" (ngSubmit)="runReport(parameterForm)">

  <div *ngIf="data.isIDIAdmin" class="form-group row">
    <label for="dealerSelect" class="col-sm-3 col-form-label" i18n>Dealer</label>
    <select required id="dealerSelect" name="dealerSelect" class="form-control select-bidit"
            #dealerSelect="ngModel"
            [(ngModel)]="data.emailLogData.dealer_ID">
      <option [ngValue]="null"></option>
      <option *ngFor="let dealer of data.dealers" [(ngValue)]="dealer.dealer_ID">{{dealer.dealer_BusinessName}}</option>
    </select>
    <div *ngIf="dealerSelect.touched && dealerSelect.invalid"
         class="alert alert-danger" i18n>
      Dealer Selection is required
    </div>
  </div>
  <div class="form-group row">
    <p i18n>Define Time Frame</p>
    <div class="control-wrapper">
      <label for="startDate" class="col-sm-3 col-form-label" i18n>Start Date</label>
      <div class="form-inline">
        <input name="startDate" id="startDate" class="form-control" matInput
               placeholder="mm/dd/yyyy"
               [matDatepicker]="startPicker"
               [(ngModel)]="data.startDate" #startDate="ngModel" />
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </div>
    </div>
    <div class="control-wrapper">
      <label for="endDate" class="col-sm-3 col-form-label" i18n>End Date</label>
      <div class="form-inline">
        <input name="endDate" id="endDate" class="form-control" matInput
               placeholder="mm/dd/yyyy"
               [matDatepicker]="endPicker"
               [(ngModel)]="data.endDate" #endDate="ngModel" />
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </div>
    </div>
  </div>
  <div class="form-group">
    <button type="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
    <button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
  </div>
</form>

